<template>
<div>

    <m-edit-text
        :label="label"
        :value="pretty"
        :custom_on_edit="onClickEdit"
        :read_only="read_only"
        :hint="hint"
        show_hint_everywhere
    />

     <m-edit-wall-time-dialog
        :title="label"
        :value="value"
        ref="edit-dialog"
        :optional="optional"
        v-on:ok="onSet($event)"
    />

</div>
</template>

<script>
const Time = require('@/js/time.js');
export default 
{
    props: {

        value: {
            type: String,
            default: function() { return null; }
        },

        timezone: {
            type: String,
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return 'Time'}
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        read_only: 
        {
            type: Boolean,
            default: function() { return false; }
        },

        hint:
        {
            type: String,
            default: function() { return null; }
        },
    },

    methods: {
        onClickEdit() {
            this.$refs['edit-dialog'].showDialog();
        },

        onSet(time)
        {
            this.$emit('input', time);
        }
    },

    computed: {
        pretty() 
        {
            if ( this.value == null ) return null;

            if ( this.timezone == null ) 
            {
                return Time.wallTimePrettyPrintUs(this.value);
            }
            else
            {
                return Time.wallTimePrettyPrintUs(this.value) + ' '+this.timezone;
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>